import { mdiDomain } from "@mdi/js"
import type { AdministrationSubviewConfig } from "@kontextwerk/control-web-frame/components/administration"
import type { OrgaViewFrameContext } from "../../../../context"

export const subviewConfig: AdministrationSubviewConfig<OrgaViewFrameContext> = {
  id: "district",
  title: "Kehrbezirk",
  tooltip:
    "Liegenschaften, Wohneinheiten und Ansprechpartner im Kehrbezirk verwalten und ihre Zuordnungen pflegen.",
  icon: mdiDomain,
  routeSegment: "district",
  getPages: (context) => [
    {
      id: "district",
      title: "Kehrbezirk",
      path: "",
    },
  ],
}
